import { render, staticRenderFns } from "./LayoutClean.vue?vue&type=template&id=c80f503e&"
import script from "./LayoutClean.vue?vue&type=script&lang=js&"
export * from "./LayoutClean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports